import { DatePipe } from "@angular/common";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Optional,
  ViewChild,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "app/auth/auth.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { BillingserviceService } from "../billingService.service";
import { ReciptFormModel, RefundFormModel } from "../Models/billdetail.model";
import * as moment from "moment";
import { GetRecoveryManagerModel } from "../Models/recoverymanager.model";
import { FormControl } from "@angular/forms";
import { ExcelRecoveryManagerComponent } from "../excel-recovery-manager/excel-recovery-manager.component";
import { RecoveryRegisterReportComponent } from "../recovery-register-report/recovery-register-report.component";
import { catchError, map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";

@Component({
  selector: "app-bill-recovery-manager",
  templateUrl: "./bill-recovery-manager.component.html",
  styleUrls: ["./bill-recovery-manager.component.scss"],
})
export class BillRecoveryManagerComponent implements OnInit {
  RefundData: RefundFormModel = {};
  ReciptData: ReciptFormModel = {};
  getRecoveryManager: GetRecoveryManagerModel[] = [];
  PaymentType: any = [];
  BnakType: any = [];
  dyanmiccheck: boolean = false;
  startdate: any;
  MinimeDate: any;
  partyid: any;
  GenerateBSWise: any;
  showspinner: boolean = false;
  finyearid: any;
  regId: any = null;
  Bill_id: any = 0;
  BillRef_id: any = 0;
  claimNo: any = 0;
  insuranceCompanyId: any;
  insuranceCompanyArray: any = [];
  RAmount: number = null;
  Rtds: number = null;
  Rdiscount: number = null;
  Rreject: number = null;
  Rcharge: number = null;
  totalAmount: number;
  insurancecheck: number = 1;
  RAmountColor: string = "antiquewhite";
  RtdsCOlor: string = "antiquewhite";
  RdiscountColor: string = "antiquewhite";
  RrejectColor: string = "antiquewhite";
  RchargeColor: string = "antiquewhite";
  totalAmountColor: string = "antiquewhite";

  insuranceCtrl: FormControl;
  minClearingDate: string;
  filteredInsurance: Observable<any[]>;
  partyCtrl: FormControl;
  filteredParty: Observable<any[]>;
  partytpaarray: any = [];
  PaytypeCtrl: FormControl;
  filteredPaytype: Observable<any[]>;
  ChequeBankCtrl: FormControl;
  filteredChequeBank: Observable<any[]>;
  clearingankCtrl: FormControl;
  filteredClearingBank: Observable<any[]>;
  constructor(
    public authService: AuthService,
    public dialog: MatDialog,
    public dashboardService: DashboardService,
    private datePipe: DatePipe,
    public opdvisitService: OpdVisitService,
    public dialogRef: MatDialogRef<BillRecoveryManagerComponent>,
    public router: Router,
    public billingservice: BillingserviceService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.ChequeBankCtrl = new FormControl();
    this.clearingankCtrl = new FormControl();
    this.PaytypeCtrl = new FormControl();
    this.getPartTpa();
    this.finyearid = this.authService.FinYears[0].pkFinYearId;
    this.ReciptData.FK_FinyearId = this.finyearid;
    this.ReciptData.FK_DepositHeadId = 1;
    this.getproductmasterconfig();
    const currentdate = this.authService.getServerDate;
    var date = moment();
    var dateIn1Months = date.subtract(1, "months");
    this.startdate = dateIn1Months.format("YYYY-MM-DD");
    this.MinimeDate = this.datePipe.transform(currentdate, "yyyy-MM-dd");
    this.minClearingDate = this.MinimeDate;
    this.getdipaymenttype();
    this.getbanktype();
    this.ReciptData.FK_PayTypeId = 0;
    this.partyid = 0;
    this.insuranceCompanyId = 0;
    this.getBillservice();
    this.GetInsuranceCompany();
    this.mapPartTpa();
  }
  closedialog() {
    this.dialogRef.close();
  }

  onChequeDateChange() {
    if (this.ReciptData.ChequeDate) {
      this.minClearingDate = this.ReciptData.ChequeDate;
      if (this.ReciptData.ClearingDate && this.ReciptData.ClearingDate < this.ReciptData.ChequeDate) {
        this.ReciptData.ClearingDate = '';
      }
    }
  }

  getPartTpa() {
    this.dashboardService.subscriptions = this.billingservice.get_partytpa().subscribe(
      (data) => this.success_partytpa(data),
      (err) => this.failed_partytpa(err)
    );
  }
  success_partytpa(data) {
    this.partytpaarray = data;
    this.mapPartTpa();
  }
  failed_partytpa(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "ok");
    }
  }
  // get Bill service
  getBillservice() {
    this.dashboardService.subscriptions = this.billingservice
      .get_BillService()
      .subscribe(
        (data) => this.success_bill(data),
        (err) => this.failed_billservice(err)
      );
  }
  success_bill(data) {
    this.billingservice.billService = data;
  }
  failed_billservice(err) { }
  //date set
  getToday(): string {
    return new Date().toISOString().split("T")[0];
  }

  checkSearchtype(type: number) {
    if (type == 1) {
      this.partyid = 0;
      this.insurancecheck = 1;
      this.getRecoveryManager = [];
    } else {
      this.insuranceCompanyId = 0;
      this.insurancecheck = 0;
      this.getRecoveryManager = [];
    }
  }
  // get configuration data
  getproductmasterconfig() {
    let BranchId = this.authService.Loggeduser.branchid;
    this.dashboardService.subscriptions = this.billingservice
      .getproductionConfrigration(BranchId)
      .subscribe((data) => {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          if (element.propertyName === "MaxRecptNoBSWise") {
            this.GenerateBSWise = element.propertyValue;
          }
        }
      });
  }

  // get party tpa
  getdipaymenttype() {
    this.PaymentType = [];
    this.dashboardService.subscriptions = this.billingservice
      .getpaymentType()
      .subscribe((data) => {
        this.PaymentType = data.filter((item) => item.pK_Id != 1);
        this.mapPaytype();
      });
  }

  //get autocomplete paytype
  //mapinsurancecompany
  mapPaytype(): void {
    this.PaytypeCtrl = new FormControl();
    this.filteredPaytype = this.PaytypeCtrl.valueChanges.pipe(
      startWith(""),
      map((state) =>
        state ? this.filterPaytype(state) : this.PaymentType.slice()
      )
    );
  }

  filterPaytype(name: string) {
    return this.PaymentType.filter(
      (state) => state.name.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getPaytypeobj(event: any) {
    var val = event.option.value;
    const inusranceid = this.PaymentType.filter((state) => state.name == val);
    this.ReciptData.FK_PayTypeId = inusranceid[0].pK_Id;
    this.chnagePaymentMode(this.ReciptData.FK_PayTypeId);
  }

  // check input data
  CheckinputPaytype(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.ReciptData.FK_PayTypeId = 0;
      this.chnagePaymentMode(this.ReciptData.FK_PayTypeId);
    }
  }
  getbanktype() {
    this.BnakType = [];
    this.dashboardService.subscriptions = this.billingservice
      .getbankType()
      .subscribe((data) => {
        this.BnakType = data;
        this.mapChequebank();
        this.mapClearingbank();
      });
  }
  //map auto complete chequebank
  CheckinputChequeBank(event: any) {
    var checkdata = event.target.value;
    if (!checkdata) {
      this.ReciptData.FK_ChqBankId = null;
    }
  }
  //map Cheque bank
  mapChequebank(): void {
    this.ChequeBankCtrl = new FormControl();
    this.filteredChequeBank = this.ChequeBankCtrl.valueChanges.pipe(
      startWith(""),
      map((state) =>
        state ? this.filtercheckbank(state) : this.BnakType.slice()
      )
    );
  }

  filtercheckbank(name: string) {
    return this.BnakType.filter(
      (state) => state.name.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getChequeBankobj(event: any) {
    var val = event.option.value;
    const inusranceid = this.BnakType.filter((state) => state.name == val);
    this.ReciptData.FK_ChqBankId = inusranceid[0].pK_Id;
  }
  //map auto complete chequebank
  CheckinputclearingBank(event: any) {
    var checkdata = event.target.value;
    if (!checkdata) {
      this.ReciptData.FK_ClrBankId = null;
    }
  }
  //map Cheque bank
  mapClearingbank(): void {
    this.clearingankCtrl = new FormControl();
    this.filteredClearingBank = this.clearingankCtrl.valueChanges.pipe(
      startWith(""),
      map((state) =>
        state ? this.filtercheckbank(state) : this.BnakType.slice()
      )
    );
  }

  getclearingBankobj(event: any) {
    var val = event.option.value;
    const inusranceid = this.BnakType.filter((state) => state.name == val);
    this.ReciptData.FK_ClrBankId = inusranceid[0].pK_Id;
  }
  // get insurance company
  GetInsuranceCompany() {
    this.insuranceCompanyArray = [];
    this.dashboardService.subscriptions = this.billingservice
      .GetInsuranceCompany()
      .subscribe((item) => {
        this.insuranceCompanyArray = item;
        this.mapInsuranceCPmany();
      });
  }

  CheckinputBlank(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.insuranceCompanyId = 0;
    }
  }
  //mapinsurancecompany
  mapInsuranceCPmany(): void {
    this.insuranceCtrl = new FormControl();
    this.filteredInsurance = this.insuranceCtrl.valueChanges.pipe(
      startWith(""),
      map((state) =>
        state ? this.filterStates(state) : this.insuranceCompanyArray.slice()
      )
    );
  }

  filterStates(name: string) {
    return this.insuranceCompanyArray.filter(
      (state) =>
        state.insuranceCoName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getInsuraceobj(event: any) {
    var val = event.option.value;
    const inusranceid = this.insuranceCompanyArray.filter(
      (state) => state.insuranceCoName == val
    );
    this.insuranceCompanyId = inusranceid[0].pK_InsuranceCoId;
  }

  // check input data
  CheckinputpartyTpa(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.partyid = 0;
    }
  }
  //autocomplete party tpa

  mapPartTpa(): void {
    this.partyCtrl = new FormControl();
    this.filteredParty = this.partyCtrl.valueChanges.pipe(
      startWith(""),
      map((party) =>
        party ? this.filterParty(party) : this.partytpaarray.slice()
      )
    );
  }

  filterParty(name: string) {
    return this.partytpaarray.filter(
      (state) => state.partyName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getPartyobj(event: any) {
    var val = event.option.value;
    const inusranceid = this.partytpaarray.filter(
      (state) => state.partyName == val
    );
    this.partyid = inusranceid[0].pkPartyId;
  }
  // filter recovery manager
  SubSearch(event, type) {
    if (type == 1) {
      if (event.target.value != "") {
        this.Bill_id = event.target.value;
        this.FilterDatarecoveryManager();
      } else {
        this.Bill_id = 0;
        this.FilterDatarecoveryManager();
      }
    } else if (type == 2) {
      if (event.target.value != "") {
        this.BillRef_id = event.target.value;
        this.FilterDatarecoveryManager();
      } else {
        this.BillRef_id = 0;
        this.FilterDatarecoveryManager();
      }
    } else if (type == 3) {
      if (event.target.value != "") {
        this.claimNo = event.target.value;
        this.FilterDatarecoveryManager();
      } else {
        this.claimNo = 0;
        this.FilterDatarecoveryManager();
      }
    }
  }
  FilterDatarecoveryManager() {
   this.recoveryArray=[];
    if (this.insuranceCompanyId > 0) {
      if (this.Bill_id == null || this.Bill_id == "") {
        this.Bill_id = 0;
      }
      if (this.BillRef_id == null || this.BillRef_id == "") {
        this.BillRef_id = 0;
      }
      if (this.claimNo == null || this.claimNo == "") {
        this.claimNo = 0;
      }
      if (this.insuranceCompanyId > 0 && this.partyid == 0) {
        this.getRecoveryManager = [];
        const branchid = this.authService.Loggeduser.branchid;
        const finyearid = this.ReciptData.FK_FinyearId;
        const InsuranceCompanyId = this.insuranceCompanyId;
        const BillSeriesId = this.ReciptData.FK_DepositHeadId;
        const billno = this.Bill_id;
        const billrefid = this.BillRef_id;
        const claimno = this.claimNo;
        this.showspinner = true;

        this.dashboardService.subscriptions = this.billingservice
          .GetRecoveryManagerByInsuranceCOmpanyId(
            branchid,
            finyearid,
            InsuranceCompanyId,
            BillSeriesId,
            billno,
            billrefid,
            claimno
          )
          .subscribe(
            (data) => this.successgetdata(data),
            (err) => this.faileddata(err)
          );
      } else if (this.partyid > 1 && this.insuranceCompanyId > 0) {
        this.getRecoveryManager = [];
        const branchid = this.authService.Loggeduser.branchid;
        const finyearid = this.ReciptData.FK_FinyearId;
        const partyid = this.partyid;
        const BillSeriesId = this.ReciptData.FK_DepositHeadId;
        const billno = this.Bill_id;
        const billrefid = this.BillRef_id;
        const claimno = this.claimNo;
        this.showspinner = true;
        this.dashboardService.subscriptions = this.billingservice
          .GetRecoveryManagerByPartyTpaId(
            branchid,
            finyearid,
            partyid,
            BillSeriesId,
            billno,
            billrefid,
            claimno
          )
          .subscribe(
            (data) => this.successgetdataParty(data),
            (err) => this.faileddata(err)
          );
      }
    } else {
      this.dashboardService.openSnackBar(
        "Please Select Insurance Biling Company",
        "OK"
      );
    }
    // type 1 mean billing company wise searching
  }

  // get recovery Manager
  // GetRecoveryManagerdata() {
  //   debugger
  //   if (this.partyid > 0) {
  //     this.getRecoveryManager = [];
  //     if (this.regId != null && this.regId != "") {
  //       this.showspinner = true;
  //       this.billingservice.GetRecoveryManagerByPartyIdByRegIdByBillIdByClaimNo(this.partyid, this.regId, 0, 0).subscribe(data => this.successgetdata(data), err => this.faileddata(err))
  //     } else if (this.Bill_id != null && this.Bill_id != "") {
  //       this.showspinner = true;
  //       this.billingservice.GetRecoveryManagerByPartyIdByRegIdByBillIdByClaimNo(this.partyid, 0, this.Bill_id, 0).subscribe(data => this.successgetdata(data), err => this.faileddata(err))
  //     } else if (this.claimNo != null && this.claimNo != "") {
  //       this.showspinner = true;
  //       this.billingservice.GetRecoveryManagerByPartyIdByRegIdByBillIdByClaimNo(this.partyid, 0, 0, this.claimNo).subscribe(data => this.successgetdata(data), err => this.faileddata(err))
  //     }

  //   } else {
  //     this.dashboardService.openSnackBar("Please Select Partyname", "OK");
  //   }

  // }
  successgetdataParty(data) {
    this.showspinner = false;
    if (data.length > 0) {
      this.getRecoveryManager = data.filter(
        (item) => item.fK_InsuranceCompanyid == this.insuranceCompanyId
      );
      // this.getRecoveryManager = data.filter(item => item.netBalance > 0);
    } else {
      this.dashboardService.openSnackBar("Data Not Found", "OK");
    }
  }
  successgetdata(data) {
    this.showspinner = false;
    if (data.length > 0) {
      this.getRecoveryManager = data;
      const showRowdata = this.getRecoveryManager[0]
      if (showRowdata && showRowdata.billDate) {
        const billDate = moment(showRowdata.billDate);
        this.MinimeDate = billDate.format('YYYY-MM-DD');
      }
      // this.getRecoveryManager = data.filter(item => item.netBalance > 0);
    } else {
      this.dashboardService.openSnackBar("Data Not Found", "OK");
    }
  }
  faileddata(err) {
    this.showspinner = false;
    this.dashboardService.openSnackBar("Api Failed", "OK");
  }
  // change payment mode
  chnagePaymentMode(e) {
    var value = e;
    if (value == 2 || value == 3 || value == 6) {
      this.dyanmiccheck = true;

      this.ReciptData.ChequeNo = null;
      this.ReciptData.ChequeDate = null;
      this.ReciptData.FK_ChqBankId = null;
    } else if (value == 4 || value == 5 || value == 7 || value == 8) {
      this.dyanmiccheck = true;

      this.ReciptData.ChequeNo = null;
      this.ReciptData.ChequeDate = null;
      this.ReciptData.FK_ChqBankId = null;
    } else {
      this.ReciptData.ChequeNo = null;
      this.ReciptData.ChequeDate = null;
      this.ReciptData.FK_ChqBankId = null;
      this.dyanmiccheck = false;
    }
  }
  //select row
  rowClicked: any;
  changeTableRowColor(idx: any) {
    if (this.rowClicked === idx) {
      // this.dyanmiccheck = false;
      this.rowClicked = -1;
    } else {
      this.rowClicked = idx;
    }
    // const selectedRow = this.getRecoveryManager[idx];
    // this.rowClicked = idx;

    // if (selectedRow && selectedRow.billDate) {
    //   const billDate = moment(selectedRow.billDate);
    //   this.MinimeDate = billDate.format('YYYY-MM-DD');
    //   this.dyanmiccheck = true; // Enable input field
    // } else {
    //   this.MinimeDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    //   this.dyanmiccheck = false;
    // }
  }

  // set changed data
  recoveryArray: any = [];

  getRecoverAmount(rowdata: any, changedvalue: any, casetype: any) {
    if (changedvalue >= 0 || changedvalue != "") {
      const checkrecovery = this.recoveryArray.filter(
        (item) => item.fk_Billd == rowdata.fk_Billd
      );
      switch (casetype) {
        case 1: {
          if (checkrecovery.length > 0) {
            checkrecovery[0].recoverAmount = parseInt(changedvalue);
          } else {
            rowdata.recoverAmount = parseInt(changedvalue);
            this.recoveryArray.push(rowdata);
          }
          break;
        }
        case 2: {
          if (checkrecovery.length > 0) {
            checkrecovery[0].tds = parseInt(changedvalue);
          } else {
            rowdata.tds = parseInt(changedvalue);
            this.recoveryArray.push(rowdata);
          }

          break;
        }
        case 3: {
          if (checkrecovery.length > 0) {
            checkrecovery[0].discount = parseInt(changedvalue);
          } else {
            rowdata.discount = parseInt(changedvalue);
            this.recoveryArray.push(rowdata);
          }

          break;
        }
        case 4: {
          if (checkrecovery.length > 0) {
            checkrecovery[0].disAllow = parseInt(changedvalue);
          } else {
            rowdata.disAllow = parseInt(changedvalue);
            this.recoveryArray.push(rowdata);
          }

          break;
        }
        case 5: {
          if (checkrecovery.length > 0) {
            checkrecovery[0].st = parseInt(changedvalue);
          } else {
            rowdata.st = parseInt(changedvalue);
            this.recoveryArray.push(rowdata);
          }

          break;
        }
        case 6: {
          if (checkrecovery.length > 0) {
            checkrecovery[0].remarks = changedvalue;
          } else {
            rowdata.remarks = changedvalue;
            this.recoveryArray.push(rowdata);
          }
          break;
        }
      }
    
      var  totalamount =0;
       var tds=0
       var discount=0;
       var disAllow=0;
       var st=0;
       var recoverAmount=0;
       tds =checkrecovery[0]?.tds ?checkrecovery[0]?.tds:0;
       discount= checkrecovery[0]?.discount ?checkrecovery[0]?.discount:0;
       disAllow= checkrecovery[0]?.disAllow ?checkrecovery[0]?.disAllow:0;
       st=checkrecovery[0]?.st ?checkrecovery[0]?.st:0;
       recoverAmount = checkrecovery[0]?.recoverAmount ?checkrecovery[0]?.recoverAmount:0;
        totalamount =Number(recoverAmount) + Number(tds) +Number( discount) +Number( disAllow) + Number(st)
      
        checkrecovery[0].totalAmt =totalamount ? totalamount: 0
        
    }

    this.CheckALlcolorCoding(this.recoveryArray);
  }
  //check all color coding
  CheckALlcolorCoding(recoveryArray: any) {
    if (recoveryArray.length > 0) {
      var recamount = 0;
      var rectds = 0;
      var recdicount = 0;
      var recdisallow = 0;
      var reccharge = 0;

      recoveryArray.forEach((item) => {
        recamount = recamount + item.recoverAmount;
        rectds = rectds + item.tds;
        recdicount = recdicount + item.discount;
        recdisallow = recdisallow + item.disAllow;
        reccharge = reccharge + item.st;
      });
      if (this.RAmount > 0) {
        if (this.RAmount > recamount) {
          this.RAmountColor = "Yellow";
        } else if (this.RAmount == recamount) {
          this.RAmountColor = "Green";
        } else if (recamount > this.RAmount) {
          this.RAmountColor = "Red";
        }
      }
      if (this.Rtds > 0) {
        if (this.Rtds > rectds) {
          this.RtdsCOlor = "Yellow";
        } else if (this.Rtds == rectds) {
          this.RtdsCOlor = "Green";
        } else if (rectds > this.Rtds) {
          this.RtdsCOlor = "Red";
        }
      }
      if (this.Rdiscount > 0) {
        if (this.Rdiscount > recdicount) {
          this.RdiscountColor = "Yellow";
        } else if (this.Rdiscount == recdicount) {
          this.RdiscountColor = "Green";
        } else if (recdicount > this.Rdiscount) {
          this.RdiscountColor = "Red";
        }
      }
      if (this.Rreject > 0) {
        if (this.Rreject > recdisallow) {
          this.RrejectColor = "Yellow";
        } else if (this.Rreject == recdisallow) {
          this.RrejectColor = "Green";
        } else if (recdisallow > this.Rreject) {
          this.RrejectColor = "Red";
        }
      }
      if (this.Rcharge > 0) {
        if (this.Rcharge > reccharge) {
          this.RchargeColor = "Yellow";
        } else if (this.Rcharge == reccharge) {
          this.RchargeColor = "Green";
        } else if (reccharge > this.Rcharge) {
          this.RchargeColor = "Red";
        }
      }
    }
  }
  //check total Input AMount
  checkTotalAmount() {
    var rtotalamount = 0;
    rtotalamount =
      this.RAmount + this.Rtds + this.Rdiscount + this.Rreject + this.Rcharge;
    if (this.totalAmount > 0) {
      if (this.totalAmount > rtotalamount) {
        this.totalAmountColor = "Yellow";
      } else if (this.totalAmount == rtotalamount) {
        this.totalAmountColor = "Green";
      } else if (rtotalamount > this.totalAmount) {
        this.totalAmountColor = "Red";
      }
    }
  }
  // check amount color coding
  checktotalamountcolor(
    netBalance: number,
    recoverAmount: number,
    tds: number,
    discount: number,
    disAllow: number,
    st: number
  ) {
    var totalvalue = recoverAmount + tds + discount + disAllow + st;
    if (netBalance > 0 && totalvalue > 0) {
      if (netBalance > totalvalue) {
        return "Yellow";
      } else if (netBalance == totalvalue) {
        return "Green";
      } else if (totalvalue > netBalance) {
        return "Red";
      }
    }
  }

  // save bill recovery
  finalRecoveryArray: any = [];
  savebillRecovery() {
    if (this.ReciptData.FK_PayTypeId > 0) {
      if (
        this.ReciptData.ChequeNo == null ||
        this.ReciptData.ChequeDate == null ||
        this.ReciptData.FK_ChqBankId == null ||
        this.ReciptData.ChequeNo == undefined ||
        this.ReciptData.ChequeDate == undefined ||
        this.ReciptData.FK_ChqBankId == undefined ||
        this.ReciptData.FK_ChqBankId == undefined ||
        this.ReciptData.FK_ClrBankId == undefined ||
        this.ReciptData.FK_ClrBankId == null ||
        this.ReciptData.TransactionRefNo == undefined
      ) {
        this.dyanmiccheck = true;
      } else {
        this.dyanmiccheck = false;
      }
    } else {
      this.dyanmiccheck = false;
      this.dashboardService.openSnackBar("Please Select Pay Type", "OK");
      return;
    }
    if (this.recoveryArray.length > 0) {
      if (this.dyanmiccheck != true) { //** */
        if (this.insuranceCompanyId > 0) {
          this.finalRecoveryArray = [];
          const removenotupdaterow = this.recoveryArray.filter(
            (item) =>
              item.recoverAmount > 0 ||
              item.tds > 0 ||
              item.discountAmt > 0 ||
              item.st > 0 ||
              item.disAllow > 0
          );
          if (removenotupdaterow.length > 0) {
            const currentdate = this.authService.getServerDate;
            var recamount = 0;
            var rectds = 0;
            var recdicount = 0;
            var recdisallow = 0;
            var reccharge = 0;
            var totalnetamount = 0;
            var totalcheckamount = 0;
            removenotupdaterow.forEach((element) => {
              totalnetamount = totalnetamount + element.netBalance;
              recamount = recamount + element.recoverAmount;
              rectds = rectds + element.tds;
              recdicount = recdicount + element.discount;
              recdisallow = recdisallow + element.disAllow;
              reccharge = reccharge + element.st;
              totalcheckamount = totalcheckamount + element.totalAmt;
            });
            //insert master

            const masterstore = {
              EntryDate: this.datePipe.transform(currentdate, "yyyy-MM-dd"),
              EntryTime: new Date().toTimeString().split(" ")[0],
              FK_CreatedByID: this.authService.Loggeduser.userid,
              FK_InsuranceCompanyid: this.insuranceCompanyId,
              FK_PayTypeId: this.ReciptData.FK_PayTypeId,
              ChequeNo: this.ReciptData.ChequeNo,
              RefBankBranch: this.ReciptData.TransactionRefNo,
              ChequeDate: this.datePipe.transform(
                this.ReciptData.ChequeDate,
                "yyyy-MM-dd"
              ),
              ClearingDate: this.datePipe.transform(
                this.ReciptData.ClearingDate,
                "yyyy-MM-dd"
              ),
              FK_ChqBankId: this.ReciptData.FK_ChqBankId,
              FK_ClrBankId: this.ReciptData.FK_ClrBankId,
              TotalAmount: totalnetamount,
              TotalAdjusted: recamount,
              TotalDiscount: recdicount,
              TotalDisAllow: recdisallow,
              TotalTDS: rectds,
              TotalST: reccharge,
              PK_TranID: 0,
            };
            if (
              recamount != 0 ||
              rectds != 0 ||
              recdicount != 0 ||
              recdisallow != 0 ||
              reccharge != 0 ||
              totalcheckamount != 0
            ) {
              if (this.RAmount == null) {
                this.RAmount = 0;
              }
              if (this.Rtds == null) {
                this.Rtds = 0;
              }
              if (this.Rdiscount == null) {
                this.Rdiscount = 0;
              }
              if (this.Rreject == null) {
                this.Rreject = 0;
              }
              if (this.Rcharge == null) {
                this.Rcharge = 0;
              }
              if (this.totalAmount == null) {
                this.totalAmount = 0;
              }
              if (this.RAmount != recamount) {
                this.dashboardService.openSnackBar(
                  "Please Insert Correct Amount",
                  "OK"
                );
                this.RAmountColor = "red";
                return;
              }
              if (this.Rtds != rectds) {
                this.dashboardService.openSnackBar(
                  "Please Insert Correct Amount",
                  "OK"
                );
                this.RtdsCOlor = "red";
                return;
              }
              if (this.Rdiscount != recdicount) {
                this.dashboardService.openSnackBar(
                  "Please Insert Correct Amount",
                  "OK"
                );
                this.RdiscountColor = "red";
                return;
              }
              if (this.Rreject != recdisallow) {
                this.dashboardService.openSnackBar(
                  "Please Insert Correct Amount",
                  "OK"
                );
                this.RrejectColor = "red";
                return;
              }
              if (this.Rcharge != reccharge) {
                this.dashboardService.openSnackBar(
                  "Please Insert Correct Amount",
                  "OK"
                );
                this.RchargeColor = "red";
                return;
              }
              if (this.totalAmount != totalcheckamount) {
                this.dashboardService.openSnackBar(
                  "Please Insert Correct Amount",
                  "OK"
                );
                this.totalAmountColor = "red";
                return;
              }
            }
            if (totalnetamount >= totalcheckamount) {
              try {
                this.finalRecoveryArray = [];
                removenotupdaterow.forEach((element) => {
                  this.finalRecoveryArray.push({
                    PaymentTime: new Date().toTimeString().split(" ")[0],
                    CurrencyAmount: element.recoverAmount,
                    PK_ReceiptId: 0,
                    ReceiptNo: 0,
                    FK_RegId: element.patientId,
                    FK_CreatedById: this.authService.Loggeduser.userid,
                    FK_CancelledById: this.authService.Loggeduser.userid,
                    PrintCount: 0,
                    IsActive: 1,
                    FK_BillingCompanyId: element.fK_BillingCompanyId,
                    FK_FinyearId: this.finyearid,
                    FK_BranchId: this.authService.Loggeduser.branchid,
                    PaymentDate: this.datePipe.transform(
                      currentdate,
                      "yyyy-MM-dd"
                    ),
                    FK_DoctorId: element.fk_DoctorId,
                    FK_DepositHeadId: element.fK_BillSerieseId,
                    FK_CurrencyId: 1,
                    FK_DepositTypeId: 4,
                    ConvertRetio: 1,
                    FK_PartyId: element.fk_PartyId,
                    AmountINR:
                      element.recoverAmount != null
                        ? element.recoverAmount
                        : 0,
                    AmountTDS: element.tds != null ? element.tds : 0,
                    AmountDiscount:
                      element.discount != null ? element.discount : 0,
                    AmountDisAllow:
                      element.disAllow != null ? element.disAllow : 0,
                    AmountST: element.st != null ? element.st : 0,
                    FK_PayTypeId: parseInt(this.ReciptData.FK_PayTypeId),
                    ChequeNo: this.ReciptData.ChequeNo,
                    ChequeDate: this.ReciptData.ChequeDate,
                    FK_ChqBankId: this.ReciptData.FK_ChqBankId,
                    RefBankBranch: this.ReciptData.TransactionRefNo,
                    FK_ClrBankId: this.ReciptData.FK_ClrBankId,
                    IsCoPayment: 0,
                    IsAdjusted: 1,
                    FK_AdjustedBillId: element.fk_Billd,
                    UserRemarks: element.remarks,
                    Iscancelled: 0,
                    RecptGenerateBSWise: this.GenerateBSWise,

                  });
                });
                this.showspinner = true;
                let payload = {
                  "RecoveryManagerMaster": masterstore,
                  "RecoveryManagerDetail": this.finalRecoveryArray
                }
                this.dashboardService.subscriptions = this.billingservice
                  .StoreRecoveryMasterData(payload)
                  .subscribe((item) => {
                    this.showspinner = false;
                    if (item.statusCode == 1) {
                      this.finalRecoveryArray = [];
                      this.dashboardService.openSnackBar(
                        "Successfully Recovered Bill Amount",
                        "OK"
                      );
                      this.clearField();
                      // this.showspinner = true;
                      // this.dashboardService.subscriptions = this.billingservice
                      //   .StoreRecoveryData(this.finalRecoveryArray)
                      //   .subscribe(
                      //     (data) => this.successRecovery(data),
                      //     (err) => this.faieldRecovery(err)
                      //   );
                    }
                  }, err => {
                    this.showspinner = false;
                    if (err.status == 403) {
                      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                    }
                    else if (err.error.statusCode == 422) {
                      this.dashboardService.openSnackBar(err.error.message, "OK");
                    }
                    else {
                      this.dashboardService.openSnackBar("API Failed", "OK");
                    }
                  });
              } catch (error) {
                // handle error
              }
            } else {
              this.dashboardService.openSnackBar(
                "Please Insert Correct Amount",
                "OK"
              );
            }
          } else {
            this.dashboardService.openSnackBar("No Updation Found ", "OK");
          }
        } else {
          this.dashboardService.openSnackBar(
            "Please Select Insurance company Name",
            "OK"
          );
        }
      } else {
        this.dashboardService.openSnackBar(
          "All Mandatory Field are required",
          "OK"
        );
      }
    } else {
      this.dashboardService.openSnackBar("No Updation Found ", "OK");
    }
  }

  successRecovery(data) {
    this.showspinner = false;
    //this.FilterDatarecoveryManager();
    this.dashboardService.openSnackBar(
      "Successfully Recovered Bill Amount",
      "OK"
    );
    this.clearField();
  }

  faieldRecovery(err) {
    this.showspinner = false;
    this.dashboardService.openSnackBar("API Failed", "OK");
  }

  // Excel Sheet Recovery Manager
  openexcelRecovery() {
    this.getRecoveryManager = [];
    const dialogRef = this.dialog.open(ExcelRecoveryManagerComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      maxHeight: "86%",
      width: "80%",
      disableClose: true,
    });

    this.dashboardService.subscriptions = dialogRef
      .afterClosed()
      .subscribe((result) => {
        if (result.length > 0) {
          this.getRecoveryManager = [];
          this.getRecoveryManager = result;
          this.CheckALlcolorCoding(this.getRecoveryManager);
        }
      });
  }
  openRecoveryRegister() {
    const dialogRef = this.dialog.open(RecoveryRegisterReportComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "100%",
      width: "100%",
      disableClose: true,
    });

    this.dashboardService.subscriptions = dialogRef
      .afterClosed()
      .subscribe((result) => { });
  }
  clearField() {
    this.getdipaymenttype();
    this.getbanktype();
    this.getRecoveryManager = [];
    this.recoveryArray = [];
    this.RAmount = 0;
    this.Rtds = 0;
    this.Rdiscount = 0;
    this.Rreject = 0;
    this.Rcharge = 0;
    this.totalAmount = 0;
    this.ReciptData.ChequeNo = null;
    this.ReciptData.ChequeDate = null;
    this.ReciptData.FK_ChqBankId = 0;
    this.ReciptData.FK_PayTypeId = 0;
    this.Bill_id = null;
    this.claimNo = null;
    this.BillRef_id = null;
    this.finyearid = this.authService.FinYears[0].pkFinYearId;
    this.ReciptData.FK_FinyearId = this.finyearid;
    this.ReciptData.FK_DepositHeadId = 1;
    this.ReciptData.FK_PayTypeId = 0;
    this.ReciptData.TransactionRefNo = null;
    this.ReciptData.ClearingDate = null;
    this.ReciptData.FK_ClrBankId = 0;
    // this.partyid = 0;
    // this.insuranceCompanyId = 0;
    const currentdate = this.authService.getServerDate;
    this.MinimeDate = this.datePipe.transform(currentdate, "yyyy-MM-dd");
    this.RAmountColor = "antiquewhite";
    this.RtdsCOlor = "antiquewhite";
    this.RdiscountColor = "antiquewhite";
    this.RrejectColor = "antiquewhite";
    this.RchargeColor = "antiquewhite";
    this.totalAmountColor = "antiquewhite";
  }

  getage(selecteddate: string) {
    const checkcdate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let currentdate = this.authService.getServerDate;
    if (checkcdate >= currentdate) {
      this.RefundData.ChequeDate = checkcdate;
    } else {
      this.RefundData.ChequeDate = this.authService.getServerDate;
    }
  }
}
